import Setting from './setting.js'
export default {
    languages: [
        {
            name: 'Français CA',
            label: 'Français',
            value: 'fr-CA'
        },
        {
            name: 'English CA',
            label: 'English',
            value: 'en-CA'
        }
    ],
    prepareValue(value) {
        if (typeof value !== 'object') {
            value = {}
        }
        for(let language in this.languages) {
            language = this.languages[language]
            if (value[language.value] === undefined) {
                value[language.value] = ''
            }
        }
        return value
    },
    isMultilingualInstance(instance) {
        let multiLingualInstances = Setting.getSetting('environment.local.multiLingualInstances')
        if (multiLingualInstances !== undefined) {
            if (!Array.isArray(multiLingualInstances)) {
                multiLingualInstances = multiLingualInstances.split(',')
            }
            for(let multiLingualInstance in multiLingualInstances) {
                multiLingualInstance = multiLingualInstances[multiLingualInstance]
                if (multiLingualInstance===instance) {
                    return true
                }
            }
        }
        return false
    }
}